// src/components/Hero.jsx
import { HERO_TAGS } from '../data/content';
import './Hero.css';

export default function Hero() {
  return (
    <section id="home" className="hero-section">
      <div className="hero-grid" />
      <div className="hero-glow" />
      <div className="hero-content container">
        <div className="hero-badge">
          <span className="pulse" />
          Now deploying AI across Indian manufacturing
        </div>
        <h1 className="hero-title">
          Industrial Intelligence<br />
          <span className="grad">Built for the Real World.</span>
        </h1>
        <p className="hero-sub">
          AI GAV INDIA PVT LTD builds AI and IoT systems that make factories smarter,
          operations leaner, and decisions faster — without disrupting what already works.
        </p>
        <div className="hero-ctas">
          <a href="#contact" className="btn btn-primary">Start a Conversation →</a>
          {/* <a href="#solutions" className="btn btn-outline">Explore Solutions</a> */}
        </div>
        <div className="hero-tags">
          {HERO_TAGS.map((tag) => (
            <span key={tag} className="hero-tag">{tag}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
